module.exports = __webpack_public_path__ + "fonts/Lato-400-latin-ext1.acf553f.woff2";